module.exports = __webpack_public_path__ + "img/B6.cabeb325.png";